"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GrpcWebError = exports.GrpcWebImpl = exports.AdServeServiceAdServeRequestDesc = exports.AdServeServiceDesc = exports.AdServeServiceClientImpl = exports.DiscoverPage_Feed = exports.DiscoverPage_FeedStyle = exports.DiscoverPage = exports.StoryItem_SccTagWeightPair = exports.StoryItem = exports.MixerInfo = exports.SubsBrandSafety = exports.AbConsoleStudyTreatmentData = exports.ABTest_DynamicConfigsEntry = exports.ABTest = exports.ClientRankingAb = exports.DebugConfig = exports.Network = exports.Device = exports.Preferences = exports.AdKitApplication = exports.Application = exports.User = exports.UserData = exports.Location = exports.ThirdPartyAdNetworkInfo = exports.AdRequest = exports.DiscoverPage_FeedStyle_Enum = exports.SubsBrandSafety_Mode = exports.Device_ATTAuthStatusType = exports.ThirdPartyAdNetworkInfo_ThirdPartySignalContentTransformation = exports.ThirdPartyAdNetworkType = void 0;
/* eslint-disable */
const grpc_web_1 = require("@improbable-eng/grpc-web");
const budget_ab_study_1 = require("../abtest/budget_ab_study");
const ad_response_1 = require("./ad_response");
const browser_headers_1 = require("browser-headers");
const long_1 = __importDefault(require("long"));
const inventory_request_1 = require("./inventory_request");
const ad_ranking_context_1 = require("./ad_ranking_context");
const lens_ranking_context_1 = require("./lens_ranking_context");
const feature_context_1 = require("./feature_context");
const prediction_study_1 = require("../abtest/prediction_study");
const client_ranking_study_1 = require("../abtest/client_ranking_study");
const webview_prefetch_study_1 = require("../abtest/webview_prefetch_study");
const init_response_1 = require("./init_response");
const value_1 = require("../../common/value");
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const wrappers_1 = require("../../google/protobuf/wrappers");
var ThirdPartyAdNetworkType;
(function (ThirdPartyAdNetworkType) {
    ThirdPartyAdNetworkType[ThirdPartyAdNetworkType["AD_NETWORK_TYPE_UNKNOWN"] = 0] = "AD_NETWORK_TYPE_UNKNOWN";
    ThirdPartyAdNetworkType[ThirdPartyAdNetworkType["AD_NETWORK_TYPE_PETRA"] = 1] = "AD_NETWORK_TYPE_PETRA";
    ThirdPartyAdNetworkType[ThirdPartyAdNetworkType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ThirdPartyAdNetworkType = exports.ThirdPartyAdNetworkType || (exports.ThirdPartyAdNetworkType = {}));
/** Determines the type of the transformation required to interpret the request_signals */
var ThirdPartyAdNetworkInfo_ThirdPartySignalContentTransformation;
(function (ThirdPartyAdNetworkInfo_ThirdPartySignalContentTransformation) {
    /** UTF8_DECODE - converts bytes to a UTF-8 string */
    ThirdPartyAdNetworkInfo_ThirdPartySignalContentTransformation[ThirdPartyAdNetworkInfo_ThirdPartySignalContentTransformation["UTF8_DECODE"] = 0] = "UTF8_DECODE";
    /** BASE64_ENCODE - converts bytes to a base64 encoded string */
    ThirdPartyAdNetworkInfo_ThirdPartySignalContentTransformation[ThirdPartyAdNetworkInfo_ThirdPartySignalContentTransformation["BASE64_ENCODE"] = 1] = "BASE64_ENCODE";
    /** PROTO - converts bytes to a PROTO */
    ThirdPartyAdNetworkInfo_ThirdPartySignalContentTransformation[ThirdPartyAdNetworkInfo_ThirdPartySignalContentTransformation["PROTO"] = 2] = "PROTO";
    ThirdPartyAdNetworkInfo_ThirdPartySignalContentTransformation[ThirdPartyAdNetworkInfo_ThirdPartySignalContentTransformation["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ThirdPartyAdNetworkInfo_ThirdPartySignalContentTransformation = exports.ThirdPartyAdNetworkInfo_ThirdPartySignalContentTransformation || (exports.ThirdPartyAdNetworkInfo_ThirdPartySignalContentTransformation = {}));
var Device_ATTAuthStatusType;
(function (Device_ATTAuthStatusType) {
    /**
     * NOT_DETERMINED - The value returned if a user has not yet received an authorization
     * request to authorize access to app-related data that can be used
     * for tracking the user or the device.
     */
    Device_ATTAuthStatusType[Device_ATTAuthStatusType["NOT_DETERMINED"] = 0] = "NOT_DETERMINED";
    /**
     * RESTRICTED - The value returned if authorization to access app-related data
     * that can be used for tracking the user or the device is restricted.
     */
    Device_ATTAuthStatusType[Device_ATTAuthStatusType["RESTRICTED"] = 1] = "RESTRICTED";
    /**
     * DENIED - The value returned if the user denies authorization to access
     * app-related data that can be used for tracking the user or the device.
     */
    Device_ATTAuthStatusType[Device_ATTAuthStatusType["DENIED"] = 2] = "DENIED";
    /**
     * AUTHORIZED - The value returned if the user authorizes access to app-related
     * data that can be used for tracking the user or the device.
     */
    Device_ATTAuthStatusType[Device_ATTAuthStatusType["AUTHORIZED"] = 3] = "AUTHORIZED";
    Device_ATTAuthStatusType[Device_ATTAuthStatusType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Device_ATTAuthStatusType = exports.Device_ATTAuthStatusType || (exports.Device_ATTAuthStatusType = {}));
var SubsBrandSafety_Mode;
(function (SubsBrandSafety_Mode) {
    SubsBrandSafety_Mode[SubsBrandSafety_Mode["UNKNOWN"] = 0] = "UNKNOWN";
    /** COMPLETE_CHECK - All subscriptions have been checked. */
    SubsBrandSafety_Mode[SubsBrandSafety_Mode["COMPLETE_CHECK"] = 1] = "COMPLETE_CHECK";
    /** PARTIAL_CHECK - Only part of the subscriptions have been checked. */
    SubsBrandSafety_Mode[SubsBrandSafety_Mode["PARTIAL_CHECK"] = 2] = "PARTIAL_CHECK";
    SubsBrandSafety_Mode[SubsBrandSafety_Mode["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(SubsBrandSafety_Mode = exports.SubsBrandSafety_Mode || (exports.SubsBrandSafety_Mode = {}));
var DiscoverPage_FeedStyle_Enum;
(function (DiscoverPage_FeedStyle_Enum) {
    /** UNKNOWN - Placeholder to identify if the field is not set. */
    DiscoverPage_FeedStyle_Enum[DiscoverPage_FeedStyle_Enum["UNKNOWN"] = 0] = "UNKNOWN";
    /** HORIZONTAL - Horizontal scrolling feeds such as the themed channels. */
    DiscoverPage_FeedStyle_Enum[DiscoverPage_FeedStyle_Enum["HORIZONTAL"] = 1] = "HORIZONTAL";
    /** VERTICAL - Vertical scrolling feeds such as FOR_YOU. */
    DiscoverPage_FeedStyle_Enum[DiscoverPage_FeedStyle_Enum["VERTICAL"] = 2] = "VERTICAL";
    DiscoverPage_FeedStyle_Enum[DiscoverPage_FeedStyle_Enum["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(DiscoverPage_FeedStyle_Enum = exports.DiscoverPage_FeedStyle_Enum || (exports.DiscoverPage_FeedStyle_Enum = {}));
function createBaseAdRequest() {
    return {
        user: undefined,
        application: undefined,
        preferences: undefined,
        device: undefined,
        network: undefined,
        inventoryRequests: [],
        isDebug: false,
        mixerInfo: undefined,
        stories: [],
        timestamp: "0",
        recentViewReceipts: [],
        discoverPage: undefined,
        clientRequestId: new Uint8Array(),
        location: undefined,
        thirdPartyAdNetworkInfos: [],
        adRankingContext: undefined,
        lensRankingContext: undefined,
        featureContext: undefined,
    };
}
exports.AdRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.user !== undefined) {
            exports.User.encode(message.user, writer.uint32(10).fork()).ldelim();
        }
        if (message.application !== undefined) {
            exports.Application.encode(message.application, writer.uint32(18).fork()).ldelim();
        }
        if (message.preferences !== undefined) {
            exports.Preferences.encode(message.preferences, writer.uint32(26).fork()).ldelim();
        }
        if (message.device !== undefined) {
            exports.Device.encode(message.device, writer.uint32(34).fork()).ldelim();
        }
        if (message.network !== undefined) {
            exports.Network.encode(message.network, writer.uint32(42).fork()).ldelim();
        }
        for (const v of message.inventoryRequests) {
            inventory_request_1.InventoryRequest.encode(v, writer.uint32(50).fork()).ldelim();
        }
        if (message.isDebug === true) {
            writer.uint32(56).bool(message.isDebug);
        }
        if (message.mixerInfo !== undefined) {
            exports.MixerInfo.encode(message.mixerInfo, writer.uint32(66).fork()).ldelim();
        }
        for (const v of message.stories) {
            exports.StoryItem.encode(v, writer.uint32(74).fork()).ldelim();
        }
        if (message.timestamp !== "0") {
            writer.uint32(80).int64(message.timestamp);
        }
        for (const v of message.recentViewReceipts) {
            writer.uint32(90).bytes(v);
        }
        if (message.discoverPage !== undefined) {
            exports.DiscoverPage.encode(message.discoverPage, writer.uint32(98).fork()).ldelim();
        }
        if (message.clientRequestId.length !== 0) {
            writer.uint32(106).bytes(message.clientRequestId);
        }
        if (message.location !== undefined) {
            exports.Location.encode(message.location, writer.uint32(114).fork()).ldelim();
        }
        for (const v of message.thirdPartyAdNetworkInfos) {
            exports.ThirdPartyAdNetworkInfo.encode(v, writer.uint32(122).fork()).ldelim();
        }
        if (message.adRankingContext !== undefined) {
            ad_ranking_context_1.AdRankingContext.encode(message.adRankingContext, writer.uint32(130).fork()).ldelim();
        }
        if (message.lensRankingContext !== undefined) {
            lens_ranking_context_1.LensRankingContext.encode(message.lensRankingContext, writer.uint32(138).fork()).ldelim();
        }
        if (message.featureContext !== undefined) {
            feature_context_1.FeatureContext.encode(message.featureContext, writer.uint32(146).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAdRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.user = exports.User.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.application = exports.Application.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.preferences = exports.Preferences.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.device = exports.Device.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.network = exports.Network.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.inventoryRequests.push(inventory_request_1.InventoryRequest.decode(reader, reader.uint32()));
                    break;
                case 7:
                    message.isDebug = reader.bool();
                    break;
                case 8:
                    message.mixerInfo = exports.MixerInfo.decode(reader, reader.uint32());
                    break;
                case 9:
                    message.stories.push(exports.StoryItem.decode(reader, reader.uint32()));
                    break;
                case 10:
                    message.timestamp = longToString(reader.int64());
                    break;
                case 11:
                    message.recentViewReceipts.push(reader.bytes());
                    break;
                case 12:
                    message.discoverPage = exports.DiscoverPage.decode(reader, reader.uint32());
                    break;
                case 13:
                    message.clientRequestId = reader.bytes();
                    break;
                case 14:
                    message.location = exports.Location.decode(reader, reader.uint32());
                    break;
                case 15:
                    message.thirdPartyAdNetworkInfos.push(exports.ThirdPartyAdNetworkInfo.decode(reader, reader.uint32()));
                    break;
                case 16:
                    message.adRankingContext = ad_ranking_context_1.AdRankingContext.decode(reader, reader.uint32());
                    break;
                case 17:
                    message.lensRankingContext = lens_ranking_context_1.LensRankingContext.decode(reader, reader.uint32());
                    break;
                case 18:
                    message.featureContext = feature_context_1.FeatureContext.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseAdRequest();
        message.user =
            object.user !== undefined && object.user !== null
                ? exports.User.fromPartial(object.user)
                : undefined;
        message.application =
            object.application !== undefined && object.application !== null
                ? exports.Application.fromPartial(object.application)
                : undefined;
        message.preferences =
            object.preferences !== undefined && object.preferences !== null
                ? exports.Preferences.fromPartial(object.preferences)
                : undefined;
        message.device =
            object.device !== undefined && object.device !== null
                ? exports.Device.fromPartial(object.device)
                : undefined;
        message.network =
            object.network !== undefined && object.network !== null
                ? exports.Network.fromPartial(object.network)
                : undefined;
        message.inventoryRequests =
            object.inventoryRequests?.map((e) => inventory_request_1.InventoryRequest.fromPartial(e)) ||
                [];
        message.isDebug = object.isDebug ?? false;
        message.mixerInfo =
            object.mixerInfo !== undefined && object.mixerInfo !== null
                ? exports.MixerInfo.fromPartial(object.mixerInfo)
                : undefined;
        message.stories =
            object.stories?.map((e) => exports.StoryItem.fromPartial(e)) || [];
        message.timestamp = object.timestamp ?? "0";
        message.recentViewReceipts = object.recentViewReceipts?.map((e) => e) || [];
        message.discoverPage =
            object.discoverPage !== undefined && object.discoverPage !== null
                ? exports.DiscoverPage.fromPartial(object.discoverPage)
                : undefined;
        message.clientRequestId = object.clientRequestId ?? new Uint8Array();
        message.location =
            object.location !== undefined && object.location !== null
                ? exports.Location.fromPartial(object.location)
                : undefined;
        message.thirdPartyAdNetworkInfos =
            object.thirdPartyAdNetworkInfos?.map((e) => exports.ThirdPartyAdNetworkInfo.fromPartial(e)) || [];
        message.adRankingContext =
            object.adRankingContext !== undefined && object.adRankingContext !== null
                ? ad_ranking_context_1.AdRankingContext.fromPartial(object.adRankingContext)
                : undefined;
        message.lensRankingContext =
            object.lensRankingContext !== undefined &&
                object.lensRankingContext !== null
                ? lens_ranking_context_1.LensRankingContext.fromPartial(object.lensRankingContext)
                : undefined;
        message.featureContext =
            object.featureContext !== undefined && object.featureContext !== null
                ? feature_context_1.FeatureContext.fromPartial(object.featureContext)
                : undefined;
        return message;
    },
};
function createBaseThirdPartyAdNetworkInfo() {
    return {
        requestSignals: new Uint8Array(),
        contentTransformation: 0,
        adNetworkType: 0,
    };
}
exports.ThirdPartyAdNetworkInfo = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.requestSignals.length !== 0) {
            writer.uint32(18).bytes(message.requestSignals);
        }
        if (message.contentTransformation !== 0) {
            writer.uint32(24).int32(message.contentTransformation);
        }
        if (message.adNetworkType !== 0) {
            writer.uint32(32).int32(message.adNetworkType);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseThirdPartyAdNetworkInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 2:
                    message.requestSignals = reader.bytes();
                    break;
                case 3:
                    message.contentTransformation = reader.int32();
                    break;
                case 4:
                    message.adNetworkType = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseThirdPartyAdNetworkInfo();
        message.requestSignals = object.requestSignals ?? new Uint8Array();
        message.contentTransformation = object.contentTransformation ?? 0;
        message.adNetworkType = object.adNetworkType ?? 0;
        return message;
    },
};
function createBaseLocation() {
    return {
        latitude: undefined,
        longitude: undefined,
        accuracyInMeters: undefined,
        locationCapturedTimestampMillis: undefined,
    };
}
exports.Location = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.latitude !== undefined) {
            wrappers_1.DoubleValue.encode({ value: message.latitude }, writer.uint32(10).fork()).ldelim();
        }
        if (message.longitude !== undefined) {
            wrappers_1.DoubleValue.encode({ value: message.longitude }, writer.uint32(18).fork()).ldelim();
        }
        if (message.accuracyInMeters !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.accuracyInMeters }, writer.uint32(26).fork()).ldelim();
        }
        if (message.locationCapturedTimestampMillis !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.locationCapturedTimestampMillis }, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLocation();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.latitude = wrappers_1.DoubleValue.decode(reader, reader.uint32()).value;
                    break;
                case 2:
                    message.longitude = wrappers_1.DoubleValue.decode(reader, reader.uint32()).value;
                    break;
                case 3:
                    message.accuracyInMeters = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 4:
                    message.locationCapturedTimestampMillis = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseLocation();
        message.latitude = object.latitude ?? undefined;
        message.longitude = object.longitude ?? undefined;
        message.accuracyInMeters = object.accuracyInMeters ?? undefined;
        message.locationCapturedTimestampMillis =
            object.locationCapturedTimestampMillis ?? undefined;
        return message;
    },
};
function createBaseUserData() {
    return {
        said: new Uint8Array(),
        isAdsHoldout: false,
        debugConfig: undefined,
        abTest: undefined,
        isEmployee: false,
        isNewUser: false,
        targetingToken: "",
        createdTimestampMillis: undefined,
        age: undefined,
        gender: 0,
        snapUserStatus: 0,
        storyAdsInUserStoriesEnabled: false,
        isPartiallyFilled: false,
        userId: new Uint8Array(),
        clientIp: new Uint8Array(),
    };
}
exports.UserData = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.said.length !== 0) {
            writer.uint32(10).bytes(message.said);
        }
        if (message.isAdsHoldout === true) {
            writer.uint32(16).bool(message.isAdsHoldout);
        }
        if (message.debugConfig !== undefined) {
            exports.DebugConfig.encode(message.debugConfig, writer.uint32(26).fork()).ldelim();
        }
        if (message.abTest !== undefined) {
            exports.ABTest.encode(message.abTest, writer.uint32(34).fork()).ldelim();
        }
        if (message.isEmployee === true) {
            writer.uint32(40).bool(message.isEmployee);
        }
        if (message.isNewUser === true) {
            writer.uint32(48).bool(message.isNewUser);
        }
        if (message.targetingToken !== "") {
            writer.uint32(58).string(message.targetingToken);
        }
        if (message.createdTimestampMillis !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.createdTimestampMillis }, writer.uint32(66).fork()).ldelim();
        }
        if (message.age !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.age }, writer.uint32(74).fork()).ldelim();
        }
        if (message.gender !== 0) {
            writer.uint32(80).int32(message.gender);
        }
        if (message.snapUserStatus !== 0) {
            writer.uint32(88).int32(message.snapUserStatus);
        }
        if (message.storyAdsInUserStoriesEnabled === true) {
            writer.uint32(96).bool(message.storyAdsInUserStoriesEnabled);
        }
        if (message.isPartiallyFilled === true) {
            writer.uint32(104).bool(message.isPartiallyFilled);
        }
        if (message.userId.length !== 0) {
            writer.uint32(114).bytes(message.userId);
        }
        if (message.clientIp.length !== 0) {
            writer.uint32(122).bytes(message.clientIp);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUserData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.said = reader.bytes();
                    break;
                case 2:
                    message.isAdsHoldout = reader.bool();
                    break;
                case 3:
                    message.debugConfig = exports.DebugConfig.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.abTest = exports.ABTest.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.isEmployee = reader.bool();
                    break;
                case 6:
                    message.isNewUser = reader.bool();
                    break;
                case 7:
                    message.targetingToken = reader.string();
                    break;
                case 8:
                    message.createdTimestampMillis = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 9:
                    message.age = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 10:
                    message.gender = reader.int32();
                    break;
                case 11:
                    message.snapUserStatus = reader.int32();
                    break;
                case 12:
                    message.storyAdsInUserStoriesEnabled = reader.bool();
                    break;
                case 13:
                    message.isPartiallyFilled = reader.bool();
                    break;
                case 14:
                    message.userId = reader.bytes();
                    break;
                case 15:
                    message.clientIp = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseUserData();
        message.said = object.said ?? new Uint8Array();
        message.isAdsHoldout = object.isAdsHoldout ?? false;
        message.debugConfig =
            object.debugConfig !== undefined && object.debugConfig !== null
                ? exports.DebugConfig.fromPartial(object.debugConfig)
                : undefined;
        message.abTest =
            object.abTest !== undefined && object.abTest !== null
                ? exports.ABTest.fromPartial(object.abTest)
                : undefined;
        message.isEmployee = object.isEmployee ?? false;
        message.isNewUser = object.isNewUser ?? false;
        message.targetingToken = object.targetingToken ?? "";
        message.createdTimestampMillis = object.createdTimestampMillis ?? undefined;
        message.age = object.age ?? undefined;
        message.gender = object.gender ?? 0;
        message.snapUserStatus = object.snapUserStatus ?? 0;
        message.storyAdsInUserStoriesEnabled =
            object.storyAdsInUserStoriesEnabled ?? false;
        message.isPartiallyFilled = object.isPartiallyFilled ?? false;
        message.userId = object.userId ?? new Uint8Array();
        message.clientIp = object.clientIp ?? new Uint8Array();
        return message;
    },
};
function createBaseUser() {
    return {
        data: undefined,
        isTestGroupQa: false,
        fsnEncryptedUserData: new Uint8Array(),
        said: new Uint8Array(),
        budgetSegmentId: 0,
    };
}
exports.User = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.data?.$case === "userData") {
            exports.UserData.encode(message.data.userData, writer.uint32(10).fork()).ldelim();
        }
        if (message.data?.$case === "encryptedUserData") {
            writer.uint32(18).bytes(message.data.encryptedUserData);
        }
        if (message.isTestGroupQa === true) {
            writer.uint32(24).bool(message.isTestGroupQa);
        }
        if (message.fsnEncryptedUserData.length !== 0) {
            writer.uint32(34).bytes(message.fsnEncryptedUserData);
        }
        if (message.said.length !== 0) {
            writer.uint32(42).bytes(message.said);
        }
        if (message.budgetSegmentId !== 0) {
            writer.uint32(48).int32(message.budgetSegmentId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUser();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.data = {
                        $case: "userData",
                        userData: exports.UserData.decode(reader, reader.uint32()),
                    };
                    break;
                case 2:
                    message.data = {
                        $case: "encryptedUserData",
                        encryptedUserData: reader.bytes(),
                    };
                    break;
                case 3:
                    message.isTestGroupQa = reader.bool();
                    break;
                case 4:
                    message.fsnEncryptedUserData = reader.bytes();
                    break;
                case 5:
                    message.said = reader.bytes();
                    break;
                case 6:
                    message.budgetSegmentId = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseUser();
        if (object.data?.$case === "userData" &&
            object.data?.userData !== undefined &&
            object.data?.userData !== null) {
            message.data = {
                $case: "userData",
                userData: exports.UserData.fromPartial(object.data.userData),
            };
        }
        if (object.data?.$case === "encryptedUserData" &&
            object.data?.encryptedUserData !== undefined &&
            object.data?.encryptedUserData !== null) {
            message.data = {
                $case: "encryptedUserData",
                encryptedUserData: object.data.encryptedUserData,
            };
        }
        message.isTestGroupQa = object.isTestGroupQa ?? false;
        message.fsnEncryptedUserData =
            object.fsnEncryptedUserData ?? new Uint8Array();
        message.said = object.said ?? new Uint8Array();
        message.budgetSegmentId = object.budgetSegmentId ?? 0;
        return message;
    },
};
function createBaseApplication() {
    return {
        appName: "",
        appVersionNumeric: "0",
        appVariant: "",
        appVariantEnum: 0,
        appType: 0,
        adKitApplication: undefined,
        appUptimeMs: undefined,
        sourceAppId: "",
        isNativeClient: false,
        appSessionId: undefined,
    };
}
exports.Application = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.appName !== "") {
            writer.uint32(10).string(message.appName);
        }
        if (message.appVersionNumeric !== "0") {
            writer.uint32(16).int64(message.appVersionNumeric);
        }
        if (message.appVariant !== "") {
            writer.uint32(26).string(message.appVariant);
        }
        if (message.appVariantEnum !== 0) {
            writer.uint32(32).int32(message.appVariantEnum);
        }
        if (message.appType !== 0) {
            writer.uint32(40).int32(message.appType);
        }
        if (message.adKitApplication !== undefined) {
            exports.AdKitApplication.encode(message.adKitApplication, writer.uint32(58).fork()).ldelim();
        }
        if (message.appUptimeMs !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.appUptimeMs }, writer.uint32(66).fork()).ldelim();
        }
        if (message.sourceAppId !== "") {
            writer.uint32(74).string(message.sourceAppId);
        }
        if (message.isNativeClient === true) {
            writer.uint32(80).bool(message.isNativeClient);
        }
        if (message.appSessionId !== undefined) {
            wrappers_1.StringValue.encode({ value: message.appSessionId }, writer.uint32(90).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseApplication();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.appName = reader.string();
                    break;
                case 2:
                    message.appVersionNumeric = longToString(reader.int64());
                    break;
                case 3:
                    message.appVariant = reader.string();
                    break;
                case 4:
                    message.appVariantEnum = reader.int32();
                    break;
                case 5:
                    message.appType = reader.int32();
                    break;
                case 7:
                    message.adKitApplication = exports.AdKitApplication.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.appUptimeMs = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 9:
                    message.sourceAppId = reader.string();
                    break;
                case 10:
                    message.isNativeClient = reader.bool();
                    break;
                case 11:
                    message.appSessionId = wrappers_1.StringValue.decode(reader, reader.uint32()).value;
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseApplication();
        message.appName = object.appName ?? "";
        message.appVersionNumeric = object.appVersionNumeric ?? "0";
        message.appVariant = object.appVariant ?? "";
        message.appVariantEnum = object.appVariantEnum ?? 0;
        message.appType = object.appType ?? 0;
        message.adKitApplication =
            object.adKitApplication !== undefined && object.adKitApplication !== null
                ? exports.AdKitApplication.fromPartial(object.adKitApplication)
                : undefined;
        message.appUptimeMs = object.appUptimeMs ?? undefined;
        message.sourceAppId = object.sourceAppId ?? "";
        message.isNativeClient = object.isNativeClient ?? false;
        message.appSessionId = object.appSessionId ?? undefined;
        return message;
    },
};
function createBaseAdKitApplication() {
    return {
        applicationIdentifier: "",
        snapkitAppId: new Uint8Array(),
        adkitSdkVersionNumeric: "0",
    };
}
exports.AdKitApplication = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.applicationIdentifier !== "") {
            writer.uint32(10).string(message.applicationIdentifier);
        }
        if (message.snapkitAppId.length !== 0) {
            writer.uint32(18).bytes(message.snapkitAppId);
        }
        if (message.adkitSdkVersionNumeric !== "0") {
            writer.uint32(24).int64(message.adkitSdkVersionNumeric);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAdKitApplication();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.applicationIdentifier = reader.string();
                    break;
                case 2:
                    message.snapkitAppId = reader.bytes();
                    break;
                case 3:
                    message.adkitSdkVersionNumeric = longToString(reader.int64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseAdKitApplication();
        message.applicationIdentifier = object.applicationIdentifier ?? "";
        message.snapkitAppId = object.snapkitAppId ?? new Uint8Array();
        message.adkitSdkVersionNumeric = object.adkitSdkVersionNumeric ?? "0";
        return message;
    },
};
function createBasePreferences() {
    return {
        limitAdTracking: false,
        audienceMatchOptOut: false,
        externalActivityMatchOptOut: false,
        thirdPartyAdNetworkOptOut: false,
        euDsaPersonalizedAdsOptOut: false,
    };
}
exports.Preferences = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.limitAdTracking === true) {
            writer.uint32(8).bool(message.limitAdTracking);
        }
        if (message.audienceMatchOptOut === true) {
            writer.uint32(16).bool(message.audienceMatchOptOut);
        }
        if (message.externalActivityMatchOptOut === true) {
            writer.uint32(24).bool(message.externalActivityMatchOptOut);
        }
        if (message.thirdPartyAdNetworkOptOut === true) {
            writer.uint32(32).bool(message.thirdPartyAdNetworkOptOut);
        }
        if (message.euDsaPersonalizedAdsOptOut === true) {
            writer.uint32(40).bool(message.euDsaPersonalizedAdsOptOut);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePreferences();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.limitAdTracking = reader.bool();
                    break;
                case 2:
                    message.audienceMatchOptOut = reader.bool();
                    break;
                case 3:
                    message.externalActivityMatchOptOut = reader.bool();
                    break;
                case 4:
                    message.thirdPartyAdNetworkOptOut = reader.bool();
                    break;
                case 5:
                    message.euDsaPersonalizedAdsOptOut = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBasePreferences();
        message.limitAdTracking = object.limitAdTracking ?? false;
        message.audienceMatchOptOut = object.audienceMatchOptOut ?? false;
        message.externalActivityMatchOptOut =
            object.externalActivityMatchOptOut ?? false;
        message.thirdPartyAdNetworkOptOut =
            object.thirdPartyAdNetworkOptOut ?? false;
        message.euDsaPersonalizedAdsOptOut =
            object.euDsaPersonalizedAdsOptOut ?? false;
        return message;
    },
};
function createBaseDevice() {
    return {
        idfa: new Uint8Array(),
        platformType: 0,
        deviceModel: "",
        osVersionNumeric: "0",
        deviceLanguage: "",
        soundIsOn: false,
        buildNumber: "",
        batteryPercent: undefined,
        isBatteryCharging: undefined,
        diskTotalSpaceKb: undefined,
        diskFreeSpaceKb: undefined,
        androidMobileServiceType: 0,
        systemUptimeMs: undefined,
        idfv: new Uint8Array(),
        attAuthStatus: 0,
        audioPlaybackVolume: undefined,
        screenWidth: undefined,
        screenHeight: undefined,
    };
}
exports.Device = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.idfa.length !== 0) {
            writer.uint32(10).bytes(message.idfa);
        }
        if (message.platformType !== 0) {
            writer.uint32(16).int32(message.platformType);
        }
        if (message.deviceModel !== "") {
            writer.uint32(26).string(message.deviceModel);
        }
        if (message.osVersionNumeric !== "0") {
            writer.uint32(32).int64(message.osVersionNumeric);
        }
        if (message.deviceLanguage !== "") {
            writer.uint32(42).string(message.deviceLanguage);
        }
        if (message.soundIsOn === true) {
            writer.uint32(48).bool(message.soundIsOn);
        }
        if (message.buildNumber !== "") {
            writer.uint32(58).string(message.buildNumber);
        }
        if (message.batteryPercent !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.batteryPercent }, writer.uint32(66).fork()).ldelim();
        }
        if (message.isBatteryCharging !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.isBatteryCharging }, writer.uint32(74).fork()).ldelim();
        }
        if (message.diskTotalSpaceKb !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.diskTotalSpaceKb }, writer.uint32(82).fork()).ldelim();
        }
        if (message.diskFreeSpaceKb !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.diskFreeSpaceKb }, writer.uint32(90).fork()).ldelim();
        }
        if (message.androidMobileServiceType !== 0) {
            writer.uint32(96).int32(message.androidMobileServiceType);
        }
        if (message.systemUptimeMs !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.systemUptimeMs }, writer.uint32(106).fork()).ldelim();
        }
        if (message.idfv.length !== 0) {
            writer.uint32(114).bytes(message.idfv);
        }
        if (message.attAuthStatus !== 0) {
            writer.uint32(120).int32(message.attAuthStatus);
        }
        if (message.audioPlaybackVolume !== undefined) {
            wrappers_1.FloatValue.encode({ value: message.audioPlaybackVolume }, writer.uint32(130).fork()).ldelim();
        }
        if (message.screenWidth !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.screenWidth }, writer.uint32(138).fork()).ldelim();
        }
        if (message.screenHeight !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.screenHeight }, writer.uint32(146).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDevice();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.idfa = reader.bytes();
                    break;
                case 2:
                    message.platformType = reader.int32();
                    break;
                case 3:
                    message.deviceModel = reader.string();
                    break;
                case 4:
                    message.osVersionNumeric = longToString(reader.int64());
                    break;
                case 5:
                    message.deviceLanguage = reader.string();
                    break;
                case 6:
                    message.soundIsOn = reader.bool();
                    break;
                case 7:
                    message.buildNumber = reader.string();
                    break;
                case 8:
                    message.batteryPercent = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 9:
                    message.isBatteryCharging = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 10:
                    message.diskTotalSpaceKb = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 11:
                    message.diskFreeSpaceKb = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 12:
                    message.androidMobileServiceType = reader.int32();
                    break;
                case 13:
                    message.systemUptimeMs = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 14:
                    message.idfv = reader.bytes();
                    break;
                case 15:
                    message.attAuthStatus = reader.int32();
                    break;
                case 16:
                    message.audioPlaybackVolume = wrappers_1.FloatValue.decode(reader, reader.uint32()).value;
                    break;
                case 17:
                    message.screenWidth = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 18:
                    message.screenHeight = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseDevice();
        message.idfa = object.idfa ?? new Uint8Array();
        message.platformType = object.platformType ?? 0;
        message.deviceModel = object.deviceModel ?? "";
        message.osVersionNumeric = object.osVersionNumeric ?? "0";
        message.deviceLanguage = object.deviceLanguage ?? "";
        message.soundIsOn = object.soundIsOn ?? false;
        message.buildNumber = object.buildNumber ?? "";
        message.batteryPercent = object.batteryPercent ?? undefined;
        message.isBatteryCharging = object.isBatteryCharging ?? undefined;
        message.diskTotalSpaceKb = object.diskTotalSpaceKb ?? undefined;
        message.diskFreeSpaceKb = object.diskFreeSpaceKb ?? undefined;
        message.androidMobileServiceType = object.androidMobileServiceType ?? 0;
        message.systemUptimeMs = object.systemUptimeMs ?? undefined;
        message.idfv = object.idfv ?? new Uint8Array();
        message.attAuthStatus = object.attAuthStatus ?? 0;
        message.audioPlaybackVolume = object.audioPlaybackVolume ?? undefined;
        message.screenWidth = object.screenWidth ?? undefined;
        message.screenHeight = object.screenHeight ?? undefined;
        return message;
    },
};
function createBaseNetwork() {
    return {
        connectionType: 0,
        mccMnc: "",
        clientIp: new Uint8Array(),
        carrier: "",
        kiloBytesPerSecond: "0",
        cellularNetworkType: 0,
    };
}
exports.Network = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.connectionType !== 0) {
            writer.uint32(8).int32(message.connectionType);
        }
        if (message.mccMnc !== "") {
            writer.uint32(18).string(message.mccMnc);
        }
        if (message.clientIp.length !== 0) {
            writer.uint32(26).bytes(message.clientIp);
        }
        if (message.carrier !== "") {
            writer.uint32(34).string(message.carrier);
        }
        if (message.kiloBytesPerSecond !== "0") {
            writer.uint32(40).int64(message.kiloBytesPerSecond);
        }
        if (message.cellularNetworkType !== 0) {
            writer.uint32(48).int32(message.cellularNetworkType);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseNetwork();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.connectionType = reader.int32();
                    break;
                case 2:
                    message.mccMnc = reader.string();
                    break;
                case 3:
                    message.clientIp = reader.bytes();
                    break;
                case 4:
                    message.carrier = reader.string();
                    break;
                case 5:
                    message.kiloBytesPerSecond = longToString(reader.int64());
                    break;
                case 6:
                    message.cellularNetworkType = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseNetwork();
        message.connectionType = object.connectionType ?? 0;
        message.mccMnc = object.mccMnc ?? "";
        message.clientIp = object.clientIp ?? new Uint8Array();
        message.carrier = object.carrier ?? "";
        message.kiloBytesPerSecond = object.kiloBytesPerSecond ?? "0";
        message.cellularNetworkType = object.cellularNetworkType ?? 0;
        return message;
    },
};
function createBaseDebugConfig() {
    return {
        isTestUser: false,
        isAutomationUser: false,
        skipInventoryCapping: false,
        testGroups: [],
    };
}
exports.DebugConfig = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.isTestUser === true) {
            writer.uint32(8).bool(message.isTestUser);
        }
        if (message.isAutomationUser === true) {
            writer.uint32(16).bool(message.isAutomationUser);
        }
        if (message.skipInventoryCapping === true) {
            writer.uint32(24).bool(message.skipInventoryCapping);
        }
        for (const v of message.testGroups) {
            writer.uint32(34).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDebugConfig();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.isTestUser = reader.bool();
                    break;
                case 2:
                    message.isAutomationUser = reader.bool();
                    break;
                case 3:
                    message.skipInventoryCapping = reader.bool();
                    break;
                case 4:
                    message.testGroups.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseDebugConfig();
        message.isTestUser = object.isTestUser ?? false;
        message.isAutomationUser = object.isAutomationUser ?? false;
        message.skipInventoryCapping = object.skipInventoryCapping ?? false;
        message.testGroups = object.testGroups?.map((e) => e) || [];
        return message;
    },
};
function createBaseClientRankingAb() {
    return { rankingSlotId: 0, segmentId: "0", experimentId: "0" };
}
exports.ClientRankingAb = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.rankingSlotId !== 0) {
            writer.uint32(8).int32(message.rankingSlotId);
        }
        if (message.segmentId !== "0") {
            writer.uint32(16).int64(message.segmentId);
        }
        if (message.experimentId !== "0") {
            writer.uint32(24).int64(message.experimentId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseClientRankingAb();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.rankingSlotId = reader.int32();
                    break;
                case 2:
                    message.segmentId = longToString(reader.int64());
                    break;
                case 3:
                    message.experimentId = longToString(reader.int64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseClientRankingAb();
        message.rankingSlotId = object.rankingSlotId ?? 0;
        message.segmentId = object.segmentId ?? "0";
        message.experimentId = object.experimentId ?? "0";
        return message;
    },
};
function createBaseABTest() {
    return {
        adLoadTestExperimentGroup: "",
        budgetAbStudy: undefined,
        skipPrediction: undefined,
        swipePrediction: undefined,
        installPrediction: undefined,
        clientRankingAbStudy: undefined,
        webviewPrefetchStudy: undefined,
        abTestUserSegment: "",
        abTestUserSegment20: "",
        storyAdsDisabled: false,
        discoverFeedCarouselAdsEnabled: false,
        discoverFeedCarouselAdsNumOrganicTilesBetweenAds: 0,
        discoverFeedCarouselAdsMinFeedAdPositionIndex: 0,
        userInAdsHoldout: false,
        adserverOgRouteToApiGw: undefined,
        isAcquiredUser: false,
        latencyDelayMs: 0,
        newUserGracePeriodDaysSinceCreation: undefined,
        discoverFeedStoryAdsNumOrganicTilesBetweenAds: undefined,
        discoverFeedStoryAdsMinFeedAdPositionIndex: undefined,
        arShoppingEnabled: false,
        webviewPrefetchThreshold: 0,
        onDeviceInventoryConfigs: undefined,
        webviewPrefetchDisableOverride: false,
        arShoppingRemoteLensEnabled: false,
        voperaVariantIdentifier: 0,
        lookserySponsoredGeoBackStudyGroup: "",
        disableBlockWebviewPreloading: false,
        isForcedExternalBrowser: false,
        shouldWebviewUrlAddClickId: false,
        webviewLightningModeSafeguardEnabled: false,
        webviewClientCrawlSafeguardEnabled: false,
        storiesRemoveInterstitial: false,
        storiesEnableThinProgressBar: false,
        storiesEnableProgressBar: false,
        shouldDeeplinkUrlAddClickId: false,
        webviewLightningModeServerRedirectUrlEnable: false,
        webviewExtendedLifecycleServerControlEnabled: false,
        lightningModeServerAppraisalScoreThreshold: 0,
        webviewLightningModeNonDoubleclickServerRedirectUrlEnable: false,
        webviewLightningModeJavascriptRedirectUrlEnable: false,
        forceExtBrowserAndroidNonPixelStar: false,
        treatmentDataForAllowlistedAbConsoleStudies: [],
        dynamicConfigs: {},
        storyAdMapExcluded: false,
        storyAdSeeMore: 0,
        clientRankingAbs: [],
    };
}
exports.ABTest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.adLoadTestExperimentGroup !== "") {
            writer.uint32(10).string(message.adLoadTestExperimentGroup);
        }
        if (message.budgetAbStudy !== undefined) {
            budget_ab_study_1.BudgetAbStudy.encode(message.budgetAbStudy, writer.uint32(18).fork()).ldelim();
        }
        if (message.skipPrediction !== undefined) {
            prediction_study_1.PredictionStudy.encode(message.skipPrediction, writer.uint32(26).fork()).ldelim();
        }
        if (message.swipePrediction !== undefined) {
            prediction_study_1.PredictionStudy.encode(message.swipePrediction, writer.uint32(34).fork()).ldelim();
        }
        if (message.installPrediction !== undefined) {
            prediction_study_1.PredictionStudy.encode(message.installPrediction, writer.uint32(42).fork()).ldelim();
        }
        if (message.clientRankingAbStudy !== undefined) {
            client_ranking_study_1.ClientRankingStudy.encode(message.clientRankingAbStudy, writer.uint32(50).fork()).ldelim();
        }
        if (message.webviewPrefetchStudy !== undefined) {
            webview_prefetch_study_1.WebviewPrefetchStudy.encode(message.webviewPrefetchStudy, writer.uint32(58).fork()).ldelim();
        }
        if (message.abTestUserSegment !== "") {
            writer.uint32(66).string(message.abTestUserSegment);
        }
        if (message.abTestUserSegment20 !== "") {
            writer.uint32(74).string(message.abTestUserSegment20);
        }
        if (message.storyAdsDisabled === true) {
            writer.uint32(80).bool(message.storyAdsDisabled);
        }
        if (message.discoverFeedCarouselAdsEnabled === true) {
            writer.uint32(88).bool(message.discoverFeedCarouselAdsEnabled);
        }
        if (message.discoverFeedCarouselAdsNumOrganicTilesBetweenAds !== 0) {
            writer
                .uint32(96)
                .int32(message.discoverFeedCarouselAdsNumOrganicTilesBetweenAds);
        }
        if (message.discoverFeedCarouselAdsMinFeedAdPositionIndex !== 0) {
            writer
                .uint32(104)
                .int32(message.discoverFeedCarouselAdsMinFeedAdPositionIndex);
        }
        if (message.userInAdsHoldout === true) {
            writer.uint32(112).bool(message.userInAdsHoldout);
        }
        if (message.adserverOgRouteToApiGw !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.adserverOgRouteToApiGw }, writer.uint32(122).fork()).ldelim();
        }
        if (message.isAcquiredUser === true) {
            writer.uint32(128).bool(message.isAcquiredUser);
        }
        if (message.latencyDelayMs !== 0) {
            writer.uint32(136).uint32(message.latencyDelayMs);
        }
        if (message.newUserGracePeriodDaysSinceCreation !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.newUserGracePeriodDaysSinceCreation }, writer.uint32(146).fork()).ldelim();
        }
        if (message.discoverFeedStoryAdsNumOrganicTilesBetweenAds !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.discoverFeedStoryAdsNumOrganicTilesBetweenAds }, writer.uint32(154).fork()).ldelim();
        }
        if (message.discoverFeedStoryAdsMinFeedAdPositionIndex !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.discoverFeedStoryAdsMinFeedAdPositionIndex }, writer.uint32(162).fork()).ldelim();
        }
        if (message.arShoppingEnabled === true) {
            writer.uint32(168).bool(message.arShoppingEnabled);
        }
        if (message.webviewPrefetchThreshold !== 0) {
            writer.uint32(181).float(message.webviewPrefetchThreshold);
        }
        if (message.onDeviceInventoryConfigs !== undefined) {
            init_response_1.OnDeviceInventoryConfigs.encode(message.onDeviceInventoryConfigs, writer.uint32(186).fork()).ldelim();
        }
        if (message.webviewPrefetchDisableOverride === true) {
            writer.uint32(192).bool(message.webviewPrefetchDisableOverride);
        }
        if (message.arShoppingRemoteLensEnabled === true) {
            writer.uint32(200).bool(message.arShoppingRemoteLensEnabled);
        }
        if (message.voperaVariantIdentifier !== 0) {
            writer.uint32(208).int32(message.voperaVariantIdentifier);
        }
        if (message.lookserySponsoredGeoBackStudyGroup !== "") {
            writer.uint32(218).string(message.lookserySponsoredGeoBackStudyGroup);
        }
        if (message.disableBlockWebviewPreloading === true) {
            writer.uint32(224).bool(message.disableBlockWebviewPreloading);
        }
        if (message.isForcedExternalBrowser === true) {
            writer.uint32(232).bool(message.isForcedExternalBrowser);
        }
        if (message.shouldWebviewUrlAddClickId === true) {
            writer.uint32(240).bool(message.shouldWebviewUrlAddClickId);
        }
        if (message.webviewLightningModeSafeguardEnabled === true) {
            writer.uint32(248).bool(message.webviewLightningModeSafeguardEnabled);
        }
        if (message.webviewClientCrawlSafeguardEnabled === true) {
            writer.uint32(256).bool(message.webviewClientCrawlSafeguardEnabled);
        }
        if (message.storiesRemoveInterstitial === true) {
            writer.uint32(264).bool(message.storiesRemoveInterstitial);
        }
        if (message.storiesEnableThinProgressBar === true) {
            writer.uint32(272).bool(message.storiesEnableThinProgressBar);
        }
        if (message.storiesEnableProgressBar === true) {
            writer.uint32(280).bool(message.storiesEnableProgressBar);
        }
        if (message.shouldDeeplinkUrlAddClickId === true) {
            writer.uint32(288).bool(message.shouldDeeplinkUrlAddClickId);
        }
        if (message.webviewLightningModeServerRedirectUrlEnable === true) {
            writer
                .uint32(296)
                .bool(message.webviewLightningModeServerRedirectUrlEnable);
        }
        if (message.webviewExtendedLifecycleServerControlEnabled === true) {
            writer
                .uint32(304)
                .bool(message.webviewExtendedLifecycleServerControlEnabled);
        }
        if (message.lightningModeServerAppraisalScoreThreshold !== 0) {
            writer
                .uint32(317)
                .float(message.lightningModeServerAppraisalScoreThreshold);
        }
        if (message.webviewLightningModeNonDoubleclickServerRedirectUrlEnable === true) {
            writer
                .uint32(320)
                .bool(message.webviewLightningModeNonDoubleclickServerRedirectUrlEnable);
        }
        if (message.webviewLightningModeJavascriptRedirectUrlEnable === true) {
            writer
                .uint32(328)
                .bool(message.webviewLightningModeJavascriptRedirectUrlEnable);
        }
        if (message.forceExtBrowserAndroidNonPixelStar === true) {
            writer.uint32(336).bool(message.forceExtBrowserAndroidNonPixelStar);
        }
        for (const v of message.treatmentDataForAllowlistedAbConsoleStudies) {
            exports.AbConsoleStudyTreatmentData.encode(v, writer.uint32(346).fork()).ldelim();
        }
        Object.entries(message.dynamicConfigs).forEach(([key, value]) => {
            exports.ABTest_DynamicConfigsEntry.encode({ key: key, value }, writer.uint32(354).fork()).ldelim();
        });
        if (message.storyAdMapExcluded === true) {
            writer.uint32(360).bool(message.storyAdMapExcluded);
        }
        if (message.storyAdSeeMore !== 0) {
            writer.uint32(368).int32(message.storyAdSeeMore);
        }
        for (const v of message.clientRankingAbs) {
            exports.ClientRankingAb.encode(v, writer.uint32(378).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseABTest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.adLoadTestExperimentGroup = reader.string();
                    break;
                case 2:
                    message.budgetAbStudy = budget_ab_study_1.BudgetAbStudy.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.skipPrediction = prediction_study_1.PredictionStudy.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.swipePrediction = prediction_study_1.PredictionStudy.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.installPrediction = prediction_study_1.PredictionStudy.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.clientRankingAbStudy = client_ranking_study_1.ClientRankingStudy.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.webviewPrefetchStudy = webview_prefetch_study_1.WebviewPrefetchStudy.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.abTestUserSegment = reader.string();
                    break;
                case 9:
                    message.abTestUserSegment20 = reader.string();
                    break;
                case 10:
                    message.storyAdsDisabled = reader.bool();
                    break;
                case 11:
                    message.discoverFeedCarouselAdsEnabled = reader.bool();
                    break;
                case 12:
                    message.discoverFeedCarouselAdsNumOrganicTilesBetweenAds =
                        reader.int32();
                    break;
                case 13:
                    message.discoverFeedCarouselAdsMinFeedAdPositionIndex =
                        reader.int32();
                    break;
                case 14:
                    message.userInAdsHoldout = reader.bool();
                    break;
                case 15:
                    message.adserverOgRouteToApiGw = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 16:
                    message.isAcquiredUser = reader.bool();
                    break;
                case 17:
                    message.latencyDelayMs = reader.uint32();
                    break;
                case 18:
                    message.newUserGracePeriodDaysSinceCreation = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 19:
                    message.discoverFeedStoryAdsNumOrganicTilesBetweenAds =
                        wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 20:
                    message.discoverFeedStoryAdsMinFeedAdPositionIndex =
                        wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 21:
                    message.arShoppingEnabled = reader.bool();
                    break;
                case 22:
                    message.webviewPrefetchThreshold = reader.float();
                    break;
                case 23:
                    message.onDeviceInventoryConfigs = init_response_1.OnDeviceInventoryConfigs.decode(reader, reader.uint32());
                    break;
                case 24:
                    message.webviewPrefetchDisableOverride = reader.bool();
                    break;
                case 25:
                    message.arShoppingRemoteLensEnabled = reader.bool();
                    break;
                case 26:
                    message.voperaVariantIdentifier = reader.int32();
                    break;
                case 27:
                    message.lookserySponsoredGeoBackStudyGroup = reader.string();
                    break;
                case 28:
                    message.disableBlockWebviewPreloading = reader.bool();
                    break;
                case 29:
                    message.isForcedExternalBrowser = reader.bool();
                    break;
                case 30:
                    message.shouldWebviewUrlAddClickId = reader.bool();
                    break;
                case 31:
                    message.webviewLightningModeSafeguardEnabled = reader.bool();
                    break;
                case 32:
                    message.webviewClientCrawlSafeguardEnabled = reader.bool();
                    break;
                case 33:
                    message.storiesRemoveInterstitial = reader.bool();
                    break;
                case 34:
                    message.storiesEnableThinProgressBar = reader.bool();
                    break;
                case 35:
                    message.storiesEnableProgressBar = reader.bool();
                    break;
                case 36:
                    message.shouldDeeplinkUrlAddClickId = reader.bool();
                    break;
                case 37:
                    message.webviewLightningModeServerRedirectUrlEnable = reader.bool();
                    break;
                case 38:
                    message.webviewExtendedLifecycleServerControlEnabled = reader.bool();
                    break;
                case 39:
                    message.lightningModeServerAppraisalScoreThreshold = reader.float();
                    break;
                case 40:
                    message.webviewLightningModeNonDoubleclickServerRedirectUrlEnable =
                        reader.bool();
                    break;
                case 41:
                    message.webviewLightningModeJavascriptRedirectUrlEnable =
                        reader.bool();
                    break;
                case 42:
                    message.forceExtBrowserAndroidNonPixelStar = reader.bool();
                    break;
                case 43:
                    message.treatmentDataForAllowlistedAbConsoleStudies.push(exports.AbConsoleStudyTreatmentData.decode(reader, reader.uint32()));
                    break;
                case 44:
                    const entry44 = exports.ABTest_DynamicConfigsEntry.decode(reader, reader.uint32());
                    if (entry44.value !== undefined) {
                        message.dynamicConfigs[entry44.key] = entry44.value;
                    }
                    break;
                case 45:
                    message.storyAdMapExcluded = reader.bool();
                    break;
                case 46:
                    message.storyAdSeeMore = reader.int32();
                    break;
                case 47:
                    message.clientRankingAbs.push(exports.ClientRankingAb.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseABTest();
        message.adLoadTestExperimentGroup = object.adLoadTestExperimentGroup ?? "";
        message.budgetAbStudy =
            object.budgetAbStudy !== undefined && object.budgetAbStudy !== null
                ? budget_ab_study_1.BudgetAbStudy.fromPartial(object.budgetAbStudy)
                : undefined;
        message.skipPrediction =
            object.skipPrediction !== undefined && object.skipPrediction !== null
                ? prediction_study_1.PredictionStudy.fromPartial(object.skipPrediction)
                : undefined;
        message.swipePrediction =
            object.swipePrediction !== undefined && object.swipePrediction !== null
                ? prediction_study_1.PredictionStudy.fromPartial(object.swipePrediction)
                : undefined;
        message.installPrediction =
            object.installPrediction !== undefined &&
                object.installPrediction !== null
                ? prediction_study_1.PredictionStudy.fromPartial(object.installPrediction)
                : undefined;
        message.clientRankingAbStudy =
            object.clientRankingAbStudy !== undefined &&
                object.clientRankingAbStudy !== null
                ? client_ranking_study_1.ClientRankingStudy.fromPartial(object.clientRankingAbStudy)
                : undefined;
        message.webviewPrefetchStudy =
            object.webviewPrefetchStudy !== undefined &&
                object.webviewPrefetchStudy !== null
                ? webview_prefetch_study_1.WebviewPrefetchStudy.fromPartial(object.webviewPrefetchStudy)
                : undefined;
        message.abTestUserSegment = object.abTestUserSegment ?? "";
        message.abTestUserSegment20 = object.abTestUserSegment20 ?? "";
        message.storyAdsDisabled = object.storyAdsDisabled ?? false;
        message.discoverFeedCarouselAdsEnabled =
            object.discoverFeedCarouselAdsEnabled ?? false;
        message.discoverFeedCarouselAdsNumOrganicTilesBetweenAds =
            object.discoverFeedCarouselAdsNumOrganicTilesBetweenAds ?? 0;
        message.discoverFeedCarouselAdsMinFeedAdPositionIndex =
            object.discoverFeedCarouselAdsMinFeedAdPositionIndex ?? 0;
        message.userInAdsHoldout = object.userInAdsHoldout ?? false;
        message.adserverOgRouteToApiGw = object.adserverOgRouteToApiGw ?? undefined;
        message.isAcquiredUser = object.isAcquiredUser ?? false;
        message.latencyDelayMs = object.latencyDelayMs ?? 0;
        message.newUserGracePeriodDaysSinceCreation =
            object.newUserGracePeriodDaysSinceCreation ?? undefined;
        message.discoverFeedStoryAdsNumOrganicTilesBetweenAds =
            object.discoverFeedStoryAdsNumOrganicTilesBetweenAds ?? undefined;
        message.discoverFeedStoryAdsMinFeedAdPositionIndex =
            object.discoverFeedStoryAdsMinFeedAdPositionIndex ?? undefined;
        message.arShoppingEnabled = object.arShoppingEnabled ?? false;
        message.webviewPrefetchThreshold = object.webviewPrefetchThreshold ?? 0;
        message.onDeviceInventoryConfigs =
            object.onDeviceInventoryConfigs !== undefined &&
                object.onDeviceInventoryConfigs !== null
                ? init_response_1.OnDeviceInventoryConfigs.fromPartial(object.onDeviceInventoryConfigs)
                : undefined;
        message.webviewPrefetchDisableOverride =
            object.webviewPrefetchDisableOverride ?? false;
        message.arShoppingRemoteLensEnabled =
            object.arShoppingRemoteLensEnabled ?? false;
        message.voperaVariantIdentifier = object.voperaVariantIdentifier ?? 0;
        message.lookserySponsoredGeoBackStudyGroup =
            object.lookserySponsoredGeoBackStudyGroup ?? "";
        message.disableBlockWebviewPreloading =
            object.disableBlockWebviewPreloading ?? false;
        message.isForcedExternalBrowser = object.isForcedExternalBrowser ?? false;
        message.shouldWebviewUrlAddClickId =
            object.shouldWebviewUrlAddClickId ?? false;
        message.webviewLightningModeSafeguardEnabled =
            object.webviewLightningModeSafeguardEnabled ?? false;
        message.webviewClientCrawlSafeguardEnabled =
            object.webviewClientCrawlSafeguardEnabled ?? false;
        message.storiesRemoveInterstitial =
            object.storiesRemoveInterstitial ?? false;
        message.storiesEnableThinProgressBar =
            object.storiesEnableThinProgressBar ?? false;
        message.storiesEnableProgressBar = object.storiesEnableProgressBar ?? false;
        message.shouldDeeplinkUrlAddClickId =
            object.shouldDeeplinkUrlAddClickId ?? false;
        message.webviewLightningModeServerRedirectUrlEnable =
            object.webviewLightningModeServerRedirectUrlEnable ?? false;
        message.webviewExtendedLifecycleServerControlEnabled =
            object.webviewExtendedLifecycleServerControlEnabled ?? false;
        message.lightningModeServerAppraisalScoreThreshold =
            object.lightningModeServerAppraisalScoreThreshold ?? 0;
        message.webviewLightningModeNonDoubleclickServerRedirectUrlEnable =
            object.webviewLightningModeNonDoubleclickServerRedirectUrlEnable ?? false;
        message.webviewLightningModeJavascriptRedirectUrlEnable =
            object.webviewLightningModeJavascriptRedirectUrlEnable ?? false;
        message.forceExtBrowserAndroidNonPixelStar =
            object.forceExtBrowserAndroidNonPixelStar ?? false;
        message.treatmentDataForAllowlistedAbConsoleStudies =
            object.treatmentDataForAllowlistedAbConsoleStudies?.map((e) => exports.AbConsoleStudyTreatmentData.fromPartial(e)) || [];
        message.dynamicConfigs = Object.entries(object.dynamicConfigs ?? {}).reduce((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = value_1.Value.fromPartial(value);
            }
            return acc;
        }, {});
        message.storyAdMapExcluded = object.storyAdMapExcluded ?? false;
        message.storyAdSeeMore = object.storyAdSeeMore ?? 0;
        message.clientRankingAbs =
            object.clientRankingAbs?.map((e) => exports.ClientRankingAb.fromPartial(e)) || [];
        return message;
    },
};
function createBaseABTest_DynamicConfigsEntry() {
    return { key: "", value: undefined };
}
exports.ABTest_DynamicConfigsEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== undefined) {
            value_1.Value.encode(message.value, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseABTest_DynamicConfigsEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.key = reader.string();
                    break;
                case 2:
                    message.value = value_1.Value.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseABTest_DynamicConfigsEntry();
        message.key = object.key ?? "";
        message.value =
            object.value !== undefined && object.value !== null
                ? value_1.Value.fromPartial(object.value)
                : undefined;
        return message;
    },
};
function createBaseAbConsoleStudyTreatmentData() {
    return {
        segmentId: 0,
        experimentId: 0,
        cofStudyName: "",
        rankingSlotId: 0,
        rankingSlotIdV2: undefined,
    };
}
exports.AbConsoleStudyTreatmentData = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.segmentId !== 0) {
            writer.uint32(8).int32(message.segmentId);
        }
        if (message.experimentId !== 0) {
            writer.uint32(16).int32(message.experimentId);
        }
        if (message.cofStudyName !== "") {
            writer.uint32(26).string(message.cofStudyName);
        }
        if (message.rankingSlotId !== 0) {
            writer.uint32(32).int32(message.rankingSlotId);
        }
        if (message.rankingSlotIdV2 !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.rankingSlotIdV2 }, writer.uint32(42).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAbConsoleStudyTreatmentData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.segmentId = reader.int32();
                    break;
                case 2:
                    message.experimentId = reader.int32();
                    break;
                case 3:
                    message.cofStudyName = reader.string();
                    break;
                case 4:
                    message.rankingSlotId = reader.int32();
                    break;
                case 5:
                    message.rankingSlotIdV2 = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseAbConsoleStudyTreatmentData();
        message.segmentId = object.segmentId ?? 0;
        message.experimentId = object.experimentId ?? 0;
        message.cofStudyName = object.cofStudyName ?? "";
        message.rankingSlotId = object.rankingSlotId ?? 0;
        message.rankingSlotIdV2 = object.rankingSlotIdV2 ?? undefined;
        return message;
    },
};
function createBaseSubsBrandSafety() {
    return { mode: 0, isBrandSafe: false };
}
exports.SubsBrandSafety = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mode !== 0) {
            writer.uint32(8).int32(message.mode);
        }
        if (message.isBrandSafe === true) {
            writer.uint32(16).bool(message.isBrandSafe);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSubsBrandSafety();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.mode = reader.int32();
                    break;
                case 2:
                    message.isBrandSafe = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseSubsBrandSafety();
        message.mode = object.mode ?? 0;
        message.isBrandSafe = object.isBrandSafe ?? false;
        return message;
    },
};
function createBaseMixerInfo() {
    return {
        storyOffset: 0,
        version: "",
        minAdsPos: 0,
        feedType: 0,
        subsBrandSafety: undefined,
    };
}
exports.MixerInfo = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.storyOffset !== 0) {
            writer.uint32(8).uint32(message.storyOffset);
        }
        if (message.version !== "") {
            writer.uint32(18).string(message.version);
        }
        if (message.minAdsPos !== 0) {
            writer.uint32(24).uint32(message.minAdsPos);
        }
        if (message.feedType !== 0) {
            writer.uint32(32).int32(message.feedType);
        }
        if (message.subsBrandSafety !== undefined) {
            exports.SubsBrandSafety.encode(message.subsBrandSafety, writer.uint32(42).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMixerInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.storyOffset = reader.uint32();
                    break;
                case 2:
                    message.version = reader.string();
                    break;
                case 3:
                    message.minAdsPos = reader.uint32();
                    break;
                case 4:
                    message.feedType = reader.int32();
                    break;
                case 5:
                    message.subsBrandSafety = exports.SubsBrandSafety.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseMixerInfo();
        message.storyOffset = object.storyOffset ?? 0;
        message.version = object.version ?? "";
        message.minAdsPos = object.minAdsPos ?? 0;
        message.feedType = object.feedType ?? 0;
        message.subsBrandSafety =
            object.subsBrandSafety !== undefined && object.subsBrandSafety !== null
                ? exports.SubsBrandSafety.fromPartial(object.subsBrandSafety)
                : undefined;
        return message;
    },
};
function createBaseStoryItem() {
    return {
        corpus: 0,
        fp: "0",
        isSubscribed: false,
        isPinned: false,
        isBrandSafeQualified: false,
        finalScore: 0,
        sccTags: [],
        userEngagementScore: 0,
        sccV3Tags: [],
    };
}
exports.StoryItem = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.corpus !== 0) {
            writer.uint32(48).int32(message.corpus);
        }
        if (message.fp !== "0") {
            writer.uint32(56).uint64(message.fp);
        }
        if (message.isSubscribed === true) {
            writer.uint32(16).bool(message.isSubscribed);
        }
        if (message.isPinned === true) {
            writer.uint32(24).bool(message.isPinned);
        }
        if (message.isBrandSafeQualified === true) {
            writer.uint32(32).bool(message.isBrandSafeQualified);
        }
        if (message.finalScore !== 0) {
            writer.uint32(41).double(message.finalScore);
        }
        for (const v of message.sccTags) {
            exports.StoryItem_SccTagWeightPair.encode(v, writer.uint32(66).fork()).ldelim();
        }
        if (message.userEngagementScore !== 0) {
            writer.uint32(77).float(message.userEngagementScore);
        }
        for (const v of message.sccV3Tags) {
            exports.StoryItem_SccTagWeightPair.encode(v, writer.uint32(82).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseStoryItem();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 6:
                    message.corpus = reader.int32();
                    break;
                case 7:
                    message.fp = longToString(reader.uint64());
                    break;
                case 2:
                    message.isSubscribed = reader.bool();
                    break;
                case 3:
                    message.isPinned = reader.bool();
                    break;
                case 4:
                    message.isBrandSafeQualified = reader.bool();
                    break;
                case 5:
                    message.finalScore = reader.double();
                    break;
                case 8:
                    message.sccTags.push(exports.StoryItem_SccTagWeightPair.decode(reader, reader.uint32()));
                    break;
                case 9:
                    message.userEngagementScore = reader.float();
                    break;
                case 10:
                    message.sccV3Tags.push(exports.StoryItem_SccTagWeightPair.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseStoryItem();
        message.corpus = object.corpus ?? 0;
        message.fp = object.fp ?? "0";
        message.isSubscribed = object.isSubscribed ?? false;
        message.isPinned = object.isPinned ?? false;
        message.isBrandSafeQualified = object.isBrandSafeQualified ?? false;
        message.finalScore = object.finalScore ?? 0;
        message.sccTags =
            object.sccTags?.map((e) => exports.StoryItem_SccTagWeightPair.fromPartial(e)) ||
                [];
        message.userEngagementScore = object.userEngagementScore ?? 0;
        message.sccV3Tags =
            object.sccV3Tags?.map((e) => exports.StoryItem_SccTagWeightPair.fromPartial(e)) ||
                [];
        return message;
    },
};
function createBaseStoryItem_SccTagWeightPair() {
    return { sccTag: 0, weight: 0 };
}
exports.StoryItem_SccTagWeightPair = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.sccTag !== 0) {
            writer.uint32(8).int32(message.sccTag);
        }
        if (message.weight !== 0) {
            writer.uint32(21).float(message.weight);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseStoryItem_SccTagWeightPair();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.sccTag = reader.int32();
                    break;
                case 2:
                    message.weight = reader.float();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseStoryItem_SccTagWeightPair();
        message.sccTag = object.sccTag ?? 0;
        message.weight = object.weight ?? 0;
        return message;
    },
};
function createBaseDiscoverPage() {
    return { mixerVersion: "", subsBrandSafety: undefined, feeds: [] };
}
exports.DiscoverPage = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mixerVersion !== "") {
            writer.uint32(10).string(message.mixerVersion);
        }
        if (message.subsBrandSafety !== undefined) {
            exports.SubsBrandSafety.encode(message.subsBrandSafety, writer.uint32(18).fork()).ldelim();
        }
        for (const v of message.feeds) {
            exports.DiscoverPage_Feed.encode(v, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDiscoverPage();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.mixerVersion = reader.string();
                    break;
                case 2:
                    message.subsBrandSafety = exports.SubsBrandSafety.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.feeds.push(exports.DiscoverPage_Feed.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseDiscoverPage();
        message.mixerVersion = object.mixerVersion ?? "";
        message.subsBrandSafety =
            object.subsBrandSafety !== undefined && object.subsBrandSafety !== null
                ? exports.SubsBrandSafety.fromPartial(object.subsBrandSafety)
                : undefined;
        message.feeds =
            object.feeds?.map((e) => exports.DiscoverPage_Feed.fromPartial(e)) || [];
        return message;
    },
};
function createBaseDiscoverPage_FeedStyle() {
    return {};
}
exports.DiscoverPage_FeedStyle = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDiscoverPage_FeedStyle();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(_) {
        const message = createBaseDiscoverPage_FeedStyle();
        return message;
    },
};
function createBaseDiscoverPage_Feed() {
    return {
        storyOffset: 0,
        feedType: 0,
        feedStyle: 0,
        adsDisabled: false,
        minAdsPos: 0,
        sccTags: [],
        stories: [],
    };
}
exports.DiscoverPage_Feed = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.storyOffset !== 0) {
            writer.uint32(8).uint32(message.storyOffset);
        }
        if (message.feedType !== 0) {
            writer.uint32(16).int32(message.feedType);
        }
        if (message.feedStyle !== 0) {
            writer.uint32(32).int32(message.feedStyle);
        }
        if (message.adsDisabled === true) {
            writer.uint32(40).bool(message.adsDisabled);
        }
        if (message.minAdsPos !== 0) {
            writer.uint32(48).uint32(message.minAdsPos);
        }
        for (const v of message.sccTags) {
            writer.uint32(58).string(v);
        }
        for (const v of message.stories) {
            exports.StoryItem.encode(v, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDiscoverPage_Feed();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.storyOffset = reader.uint32();
                    break;
                case 2:
                    message.feedType = reader.int32();
                    break;
                case 4:
                    message.feedStyle = reader.int32();
                    break;
                case 5:
                    message.adsDisabled = reader.bool();
                    break;
                case 6:
                    message.minAdsPos = reader.uint32();
                    break;
                case 7:
                    message.sccTags.push(reader.string());
                    break;
                case 3:
                    message.stories.push(exports.StoryItem.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseDiscoverPage_Feed();
        message.storyOffset = object.storyOffset ?? 0;
        message.feedType = object.feedType ?? 0;
        message.feedStyle = object.feedStyle ?? 0;
        message.adsDisabled = object.adsDisabled ?? false;
        message.minAdsPos = object.minAdsPos ?? 0;
        message.sccTags = object.sccTags?.map((e) => e) || [];
        message.stories =
            object.stories?.map((e) => exports.StoryItem.fromPartial(e)) || [];
        return message;
    },
};
class AdServeServiceClientImpl {
    rpc;
    constructor(rpc) {
        this.rpc = rpc;
        this.AdServeRequest = this.AdServeRequest.bind(this);
    }
    AdServeRequest(request, metadata) {
        return this.rpc.unary(exports.AdServeServiceAdServeRequestDesc, exports.AdRequest.fromPartial(request), metadata);
    }
}
exports.AdServeServiceClientImpl = AdServeServiceClientImpl;
exports.AdServeServiceDesc = {
    serviceName: "snapchat.ads.request.schema.AdServeService",
};
exports.AdServeServiceAdServeRequestDesc = {
    methodName: "AdServeRequest",
    service: exports.AdServeServiceDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary() {
            return exports.AdRequest.encode(this).finish();
        },
    },
    responseType: {
        deserializeBinary(data) {
            return {
                ...ad_response_1.AdResponse.decode(data),
                toObject() {
                    return this;
                },
            };
        },
    },
};
class GrpcWebImpl {
    host;
    options;
    constructor(host, options) {
        this.host = host;
        this.options = options;
    }
    unary(methodDesc, _request, metadata) {
        const request = { ..._request, ...methodDesc.requestType };
        const maybeCombinedMetadata = metadata && this.options.metadata
            ? new browser_headers_1.BrowserHeaders({
                ...this.options?.metadata.headersMap,
                ...metadata?.headersMap,
            })
            : metadata || this.options.metadata;
        return new Promise((resolve, reject) => {
            grpc_web_1.grpc.unary(methodDesc, {
                request,
                host: this.host,
                metadata: maybeCombinedMetadata,
                transport: this.options.transport,
                debug: this.options.debug,
                onEnd: function (response) {
                    if (response.status === grpc_web_1.grpc.Code.OK) {
                        resolve(response.message);
                    }
                    else {
                        const err = new GrpcWebError(response.statusMessage, response.status, response.trailers);
                        reject(err);
                    }
                },
            });
        });
    }
}
exports.GrpcWebImpl = GrpcWebImpl;
function longToString(long) {
    return long.toString();
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
class GrpcWebError extends Error {
    code;
    metadata;
    constructor(message, code, metadata) {
        super(message);
        this.code = code;
        this.metadata = metadata;
    }
}
exports.GrpcWebError = GrpcWebError;
//# sourceMappingURL=ad_request.js.map